export default function SearchIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.85832 5.47576C9.61662 5.16166 10.4294 5 11.2502 5C12.0709 5 12.8837 5.16166 13.642 5.47576C14.4003 5.78986 15.0893 6.25025 15.6697 6.83063C16.2501 7.41101 16.7104 8.10002 17.0245 8.85832C17.3386 9.61663 17.5003 10.4294 17.5003 11.2502C17.5003 12.0709 17.3386 12.8837 17.0245 13.642C16.8389 14.0901 16.6022 14.514 16.3198 14.9056L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L14.9057 16.3199C13.8481 17.0824 12.5707 17.5003 11.2502 17.5003C9.59251 17.5003 8.00276 16.8418 6.83063 15.6697C5.6585 14.4975 5 12.9078 5 11.2502C5 9.59251 5.6585 8.00276 6.83063 6.83063C7.41101 6.25025 8.10002 5.78986 8.85832 5.47576ZM11.2502 7C10.692 7 10.1393 7.10993 9.62369 7.32352C9.10804 7.53711 8.6395 7.85018 8.24484 8.24484C7.44778 9.0419 7 10.1229 7 11.2502C7 12.3774 7.44778 13.4584 8.24484 14.2555C9.0419 15.0525 10.1229 15.5003 11.2502 15.5003C12.3774 15.5003 13.4584 15.0525 14.2555 14.2555C14.6501 13.8608 14.9632 13.3923 15.1768 12.8766C15.3904 12.361 15.5003 11.8083 15.5003 11.2502C15.5003 10.692 15.3904 10.1393 15.1768 9.62369C14.9632 9.10804 14.6501 8.6395 14.2555 8.24484C13.8608 7.85018 13.3923 7.53711 12.8766 7.32352C12.361 7.10993 11.8083 7 11.2502 7Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
